import { render, staticRenderFns } from "./FormPic.vue?vue&type=template&id=80239fc2&scoped=true"
import script from "./FormPic.vue?vue&type=script&lang=ts"
export * from "./FormPic.vue?vue&type=script&lang=ts"
import style0 from "./FormPic.vue?vue&type=style&index=0&id=80239fc2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80239fc2",
  null
  
)

export default component.exports